<div>
    <navbar-cmp>
    </navbar-cmp>
    <div>
        <router-outlet>
        </router-outlet>
    </div>
    <footer-cmp></footer-cmp>
</div>
